import React, { useState, cloneElement, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import { TokenContext } from '../../App';
  
  
const ModalComponent = ({children, title, ModalTitle,  CustomButton, token, className, onOpen}) => {
    const [open, setOpen] = useState(false);
    const [encodedAccessToken] = useContext(TokenContext) 

    const decodedToken = jwtDecode(token || encodedAccessToken)
    const userRole = decodedToken.role
    

    const handleOpenModal = async () => { 
        if (userRole == 'viewer') { 
            toast.info("Viewer cannot perform that action") 
            return
        }
        
        // 如果有 onOpen 回调函数，先执行它
        if (onOpen) {
            const shouldOpen = await onOpen();
            if (shouldOpen === false) {
                return; // 如果回调返回 false，不打开模态框
            }
        }
        
        setOpen(true)
    }

    const handleCloseModal = () => {
        setOpen(false);
    };
    
    return (
        <div className={className}>
            {
                CustomButton? 
                ( <button className='cursor-pointer' onClick={handleOpenModal}> 
                    <CustomButton  />    
                </button>)
                : 
                (<button onClick={handleOpenModal} className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg cursor-pointer">
                    {title}
                </button>) 
            }

            <Dialog open={open} onClose={() => setOpen(false)}>
                <div className='flex justify-between py-3 px-4'>
                    <h2 className="text-lg font-semibold mt-1"> {ModalTitle || title} </h2>
                    <Button onClick={() => setOpen(false)}> X </Button>
                </div>
                <hr/>
                {/* {children} */}
                {React.cloneElement(children, { handleCloseModal: handleCloseModal })}  {/* To supposedly pass a prop within this to the children within it */}
            </Dialog>
        </div>
    );
};

export default ModalComponent;      